import { render, staticRenderFns } from "./AccountAlerts.vue?vue&type=template&id=67741d74&scoped=true&"
import script from "./AccountAlerts.vue?vue&type=script&lang=js&"
export * from "./AccountAlerts.vue?vue&type=script&lang=js&"
import style0 from "./AccountAlerts.vue?vue&type=style&index=0&id=67741d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67741d74",
  null
  
)

export default component.exports